import { useCallback, useEffect, useState } from "react";

// Owns the active-index state of a suggestion listbox: clamps the index to
// the candidate count, resets it whenever the candidate set changes
// (`resetKey` is a stable serialization of the candidates), and implements
// ArrowUp/ArrowDown wraparound. handleArrowKey returns whether it consumed
// the key so hosts can preventDefault exactly when navigation happened.
export const useSuggestionNavigation = (count: number, resetKey: string) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setActiveIndex(0);
  }, [resetKey]);

  const handleArrowKey = useCallback(
    (key: string): boolean => {
      if (count === 0) return false;

      if (key === "ArrowDown") {
        setActiveIndex((index) => (index + 1) % count);

        return true;
      }

      if (key === "ArrowUp") {
        setActiveIndex((index) => (index - 1 + count) % count);

        return true;
      }

      return false;
    },
    [count]
  );

  return {
    activeIndex: count === 0 ? 0 : Math.min(activeIndex, count - 1),
    handleArrowKey,
    setActiveIndex,
  };
};
